import React, { Component } from 'react';
import Movies from './../Components/Movies';

export default class Home extends Component {
	render() {
		return (
			<Movies />
		)
	}
}


// WEBPACK FOOTER //
// ./src/Layouts/Home.js